import { DayTableModel, identity } from "@fullcalendar/react";
import queryString from "query-string";

import medusaRequest, { multipartRequest } from "./request";

const removeNullish = (obj) =>
  Object.entries(obj).reduce((a, [k, v]) => (v ? ((a[k] = v), a) : a), {});

const buildQueryFromObject = (search, prefix = "") =>
  Object.entries(search)
    .map(([key, value]) =>
      typeof value === "object"
        ? buildQueryFromObject(value, key)
        : `${prefix ? `${prefix}[${key}]` : `${key}`}=${value}`
    )
    .join("&");

export default {
  products: {
    retrieve(productId) {
      const path = `/store/products/${productId}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const clean = removeNullish(search);
      const params = Object.keys(clean)
        .map((k) => `${k}=${clean[k]}`)
        .join("&");
      const path = `/store/products${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    searchStyles(search = {}) {
      const path = `/store/products/search`;
      return medusaRequest("POST", path, search);
    },
  },

  collections: {
    retrieve(id) {
      const path = `/store/collections/${id}`;
      return medusaRequest("GET", path);
    },

    list(search = {}) {
      const clean = removeNullish(search);
      const params = Object.keys(clean)
        .map((k) => `${k}=${search[k]}`)
        .filter((s) => !!s)
        .join("&");

      const path = `/store/collections${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  users: {
    retrieve(userId) {
      const path = `/store/users/${userId}`;
      return medusaRequest("GET", path);
    },
  },
  post: {
    retrieve(id) {
      const path = `/store/post/${id}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/store/post${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    searchPosts(search = {}) {
      const path = `/store/post/search-posts`;
      return medusaRequest("POST", path, search);
    },
  },
  social: {
    getcount(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");

      const path = `/store/userrelation/counts${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
};
